import validation from '../../../../../validation/index.js'
import rules from '../../../../../validation/rules/index.js'

const getListParamRules = {
  id: validation.rules.string().required().label('Organization ID'),
  productId: validation.rules.string().required().label('Product ID'),
}

const getListQueryRules = {
  category: rules.string().oneOf([
    'top-priority',
    'easy-fix',
    'high-priority-fix',
    'improve-practice',
  ]).label('Category'),
  offset: rules.string().integer().label('Offset'),
  limit: rules.string().integer().label('Limit'),
}

const getListParams = {
  rules: getListParamRules,
  schema: validation.schema(getListParamRules),
}

const getListQuery = {
  rules: getListQueryRules,
  schema: validation.schema(getListQueryRules),
}

/**
 * Where an answer was given. The wizard itself sends nothing; the policy-evaluation
 * screen sends `policy-evaluation`, which keeps its answers out of the wizard's resume
 * bookmark (see the backend's `services/productPrivacyIssue/README.md`).
 */
export const POLICY_EVALUATION_ANSWER_SOURCE = 'policy-evaluation'

export const ANSWER_SOURCES = [ POLICY_EVALUATION_ANSWER_SOURCE ] as const

const putBodyRules = {
  answers: rules.array().of(rules.lazy(value => typeof value === 'object'
    ? rules.object() : rules.string())).label('Answers'),
  source: rules.string().oneOf([ ...ANSWER_SOURCES ]).label('Source'),
}

const putParamRules = {
  id: validation.rules.string().required().label('Organization ID'),
  productId: validation.rules.string().required().label('Product ID'),
  privacyIssueId: validation.rules.string().required().label('Privacy Issue ID'),
}

const putParams = {
  rules: putParamRules,
  schema: validation.schema(putParamRules),
}

const putBody = {
  rules: putBodyRules,
  schema: validation.schema(putBodyRules),
}

export const put = {
  body: putBody,
  params: putParams,
}

export const get = { params: putParams }

export const getList = {
  params: getListParams,
  query: getListQuery,
}
